import { supabase } from "@/integrations/supabase/client";

export interface SessionDebtItem {
  id: string;
  user_id: string;
  gym_id: string;
  source_subscription_id: string | null;
  debt_sessions: number;
  status: "pending" | "applied" | "cancelled";
  applied_to_subscription_id: string | null;
  computed_at: string;
  applied_at: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
  client: { id: string; first_name: string | null; last_name: string | null } | null;
  source_subscription: {
    id: string;
    type: string;
    start_date: string;
    end_date: string;
    sessions_total: number;
  } | null;
}

export interface SessionDebtsListResponse {
  debts: SessionDebtItem[];
  total_clients: number;
  total_sessions: number;
}

async function invoke<T = any>(body: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke("session-debts-manager", { body });
  if (error) throw error;
  if (data?.error) throw new Error(data.error);
  return data as T;
}

export const sessionDebtsApi = {
  list: (gym_id: string) => invoke<SessionDebtsListResponse>({ action: "list", gym_id }),
  scanAll: (gym_id: string) =>
    invoke<{ processed: number; created: number; updated: number; cleared: number }>({
      action: "scan_all",
      gym_id,
    }),
  recomputeUser: (gym_id: string, user_id: string) =>
    invoke({ action: "recompute_user", gym_id, user_id }),
  cancel: (gym_id: string, debt_id: string, notes?: string) =>
    invoke({ action: "cancel", gym_id, debt_id, notes }),
};
